'use client';

import { useEffect } from 'react';
import Button, { ButtonTheme } from './components/Button';
import TagDivider from './components/TagDivider';


const locales = {
  ar: {
    postsTitle: 'المزيد',
    text: 'حدث خطأ غير متوقع!',
    buttons: [
      {
        title: 'الصفحة الرئيسية',
        href: '/'
      },
      {
        title: 'تواصل معنا',
        href: '/contact-us'
      },
      {
        title: 'من نحن',
        href: '/about-us'
      },

    ]

  },
  en: {
    postsTitle: 'More',
    text: 'Sorry this page does not exist',
    buttons: [
      {
        title: 'Home page',
        href: '/'
      },
      {
        title: 'Contact us',
        href: '/contact-us'
      },
      {
        title: 'About us',
        href: '/about-us'
      },
    ]
  },
}

export default function Error({
  error,
  reset,
  ...rest
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {

  const locale = 'ar';
  useEffect(() => {
    console.error(JSON.stringify(error.message));
  },[error]);
  return (
    <div className="h-full flex flex-col dark:[&>*]:text-white pb-[125px] pt-[100px] px-[24px] desktop:px-0">
      <div className='flex flex-col desktop:px-[50x] gap-y-[50px]'>
      <h1 className="text-primary-300">{locales[locale].text}</h1>
      <div className="flex items-center flex-wrap gap-[24px]">
        {locales[locale].buttons.map((b: any) => <Button locale={'ar'} key={b.title} {...b} href={`${b.href}`} theme={ButtonTheme.secondary} />)}
      </div>
      </div>
    </div>
  )
}